// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VersionActionResponse
 */
export interface VersionActionResponse {
    /**
     * 
     * @type {string}
     * @memberof VersionActionResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof VersionActionResponse
     */
    version: string;
}

/**
 * Check if a given object implements the VersionActionResponse interface.
 */
export function instanceOfVersionActionResponse(value: object): value is VersionActionResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function VersionActionResponseFromJSON(json: any): VersionActionResponse {
    return VersionActionResponseFromJSONTyped(json, false);
}

export function VersionActionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionActionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'version': json['version'],
    };
}

export function VersionActionResponseToJSON(json: any): VersionActionResponse {
    return VersionActionResponseToJSONTyped(json, false);
}

export function VersionActionResponseToJSONTyped(value?: VersionActionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'version': value['version'],
    };
}
